import { buildStoreCache } from './storeCache';
export const buildIndexValuesCache = () => {
    const responseCache = buildStoreCache();
    const pendingQueryCache = buildStoreCache();
    const queryCache = ({ storeId, field }) => {
        return (responseCache
            .queryCache(storeId, field)
            .map(response => Promise.resolve(response))
            .alt(pendingQueryCache.queryCache(storeId, field)));
    };
    const addQueryToCache = ({ storeId, field }, query) => {
        pendingQueryCache.addValueToStoreCache(storeId, field, query);
        query
            .then(queryResponse => {
            // if not in the cache, it means cache has been emptied in the meantime (because of store mutation) so it's obsolete
            if (pendingQueryCache.queryCache(storeId, field)) {
                responseCache.addValueToStoreCache(storeId, field, queryResponse);
            }
        })
            .finally(() => {
            pendingQueryCache.deleteKeyFromStore(storeId, field);
        });
    };
    const deleteStoreCache = (storeId) => {
        responseCache.deleteStoreCache(storeId);
        pendingQueryCache.deleteStoreCache(storeId);
    };
    return {
        queryCache,
        addQueryToCache,
        deleteStoreCache,
    };
};
